module.exports = __webpack_public_path__ + "img/IAR19.44d6dfca.png";